// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/thinking_square.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/thinking_square_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/thinking_square_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageInputBox_container__DZXSr {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-left: 63px;
}
.MessageInputBox_textarea_box__bP5Eo {
    position: relative;
    width: 100%;
}

.MessageInputBox_custom_textarea__hpo98 {
    /* width: 100%;
    height: 100% !important;
    min-height: 48px !important;
    max-height: 100% !important;
    padding-right: 40px;
    overflow-y: auto */
    min-height: 48px !important;
    padding: 10px 35px 10px 10px;
    font-size: 16px;
}

.MessageInputBox_custom_textarea__hpo98:hover,
.MessageInputBox_custom_textarea__hpo98:focus-within,
.MessageInputBox_custom_textarea__hpo98:focus {
    border-color: #17a8b5;
}

/* 自定义滚动条 */
.MessageInputBox_custom_textarea__hpo98::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.MessageInputBox_custom_textarea__hpo98::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.MessageInputBox_custom_textarea__hpo98::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
    cursor: default;
}

.MessageInputBox_send_butn_img__qVJs\\+ {
    position: absolute;
    right: 10px;
    bottom: 15px;
    cursor: pointer;
}

@keyframes MessageInputBox_spin__I1WyK {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.MessageInputBox_thinking_loading_box__7lfPZ {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 9px;
    top: 9px;
    cursor: pointer;
    border-radius: 100%;
    -webkit-user-select: none;
            user-select: none;
}

.MessageInputBox_circle_img__efFB\\+ {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 0px;
    top: 0px;
    animation: MessageInputBox_spin__I1WyK 2s linear infinite;
}

.MessageInputBox_square_img__UmHry {
    width: 12px;
    height: 12px;
    position: absolute;
    right: 10px;
    top: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    transition: background 0.5s, box-shadow 0.5s;
}


/* 隐藏伪元素用来预加载悬停背景图 */
.MessageInputBox_thinking_loading_box__7lfPZ::before .MessageInputBox_square_img__UmHry {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.MessageInputBox_thinking_loading_box__7lfPZ::after .MessageInputBox_square_img__UmHry {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.MessageInputBox_thinking_loading_box__7lfPZ:hover .MessageInputBox_square_img__UmHry {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
}

.MessageInputBox_thinking_loading_box__7lfPZ:active .MessageInputBox_square_img__UmHry {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
}


.MessageInputBox_textarea_explain__EzBNB {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 38px;
    padding: 13px 0;
    font-size: 12px;
    color: #9A9B9F;
}

.MessageInputBox_error_box__t0ZX7,
.MessageInputBox_suggestion_box__kOKVC {
    position: absolute;
    left: 0;
    /* top: -75px; */
    top: -50px;
    width: 100%;
    /* height: 75px; */
    height: 50px;
    background-color: #fff;
    padding-left: 63px;
}

.MessageInputBox_suggestion_title__eOS26 {
    display: flex;
    width: 100%;
    height: 25px;
    font-size: 13px;
    color: #9A9B9F;
}

.MessageInputBox_suggestion_item_box__TZ90G {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 35px;
}

.MessageInputBox_item__UG-y0 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    border-radius: 20px;
    padding: 5px 20px;
    border: 1px solid #C1C1C1;
    cursor: pointer;
    text-align: center;
}

.MessageInputBox_item__UG-y0:hover {
    background-color: #e4f0f2;
}

.MessageInputBox_item1__xGBv4 {
    width: 100%;
}

.MessageInputBox_item2__T2Wq6 {
    width: 49%;
}

.MessageInputBox_item3__rGYQt {
    width: 32%;
}

.MessageInputBox_item_text__zFplw {
    width: 100%;
    height: 100%;
    font-size: 16px;
    color: #4f4f4f;
    line-height: 23px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.MessageInputBox_error_message_box__Tsq6f {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 35px;
    height: 42px;
    margin-top: 4px;
}

.MessageInputBox_error_message__myzrx {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 12px;
    border: 1px solid #E31A1A;
    border-radius: 6px;
    font-size: 16px;
    color: #E31A1A;
    background-color: #fde0d0;
}

.MessageInputBox_error_icon__5sJTi {
    margin-right: 12px;
}
.MessageInputBox_content_mobile__xeWuX {
    padding-left: 0!important;
}
.MessageInputBox_content_mobile__xeWuX .MessageInputBox_suggestion_box__kOKVC {
    padding-left: 0;
}
.MessageInputBox_content_mobile__xeWuX .MessageInputBox_textarea_explain__EzBNB {
    display: none;
}
.MessageInputBox_content_mobile__xeWuX .MessageInputBox_suggestion_box__kOKVC {
    display: none;
}
.MessageInputBox_content_mobile__xeWuX .MessageInputBox_item_text__zFplw {
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/MessageInputBox/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;;;;;sBAKkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA,WAAW;AACX,4DAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,kEAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,yDAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,gFAAuF;IACvF,4CAA4C;AAChD;;;AAGA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAA6F;IAC7F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gFAA8F;IAC9F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAA6F;AACjG;;AAEA;IACI,gFAA8F;AAClG;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,OAAO;IACP,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB","sourcesContent":[".container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding-left: 63px;\n}\n.textarea_box {\n    position: relative;\n    width: 100%;\n}\n\n.custom_textarea {\n    /* width: 100%;\n    height: 100% !important;\n    min-height: 48px !important;\n    max-height: 100% !important;\n    padding-right: 40px;\n    overflow-y: auto */\n    min-height: 48px !important;\n    padding: 10px 35px 10px 10px;\n    font-size: 16px;\n}\n\n.custom_textarea:hover,\n.custom_textarea:focus-within,\n.custom_textarea:focus {\n    border-color: #17a8b5;\n}\n\n/* 自定义滚动条 */\n.custom_textarea::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n    cursor: default;\n}\n\n.send_butn_img {\n    position: absolute;\n    right: 10px;\n    bottom: 15px;\n    cursor: pointer;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.thinking_loading_box {\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    right: 9px;\n    top: 9px;\n    cursor: pointer;\n    border-radius: 100%;\n    user-select: none;\n}\n\n.circle_img {\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    animation: spin 2s linear infinite;\n}\n\n.square_img {\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    background: url('../../../../statics/thinking_square.png') no-repeat center / 100% 100%;\n    transition: background 0.5s, box-shadow 0.5s;\n}\n\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.thinking_loading_box::before .square_img {\n    content: \"\";\n    background: url('../../../../statics/thinking_square_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.thinking_loading_box::after .square_img {\n    content: \"\";\n    background: url('../../../../statics/thinking_square_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.thinking_loading_box:hover .square_img {\n    background: url('../../../../statics/thinking_square_hover.png') no-repeat center / 100% 100%;\n}\n\n.thinking_loading_box:active .square_img {\n    background: url('../../../../statics/thinking_square_active.png') no-repeat center / 100% 100%;\n}\n\n\n.textarea_explain {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    width: 100%;\n    height: 38px;\n    padding: 13px 0;\n    font-size: 12px;\n    color: #9A9B9F;\n}\n\n.error_box,\n.suggestion_box {\n    position: absolute;\n    left: 0;\n    /* top: -75px; */\n    top: -50px;\n    width: 100%;\n    /* height: 75px; */\n    height: 50px;\n    background-color: #fff;\n    padding-left: 63px;\n}\n\n.suggestion_title {\n    display: flex;\n    width: 100%;\n    height: 25px;\n    font-size: 13px;\n    color: #9A9B9F;\n}\n\n.suggestion_item_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 35px;\n}\n\n.item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    border-radius: 20px;\n    padding: 5px 20px;\n    border: 1px solid #C1C1C1;\n    cursor: pointer;\n    text-align: center;\n}\n\n.item:hover {\n    background-color: #e4f0f2;\n}\n\n.item1 {\n    width: 100%;\n}\n\n.item2 {\n    width: 49%;\n}\n\n.item3 {\n    width: 32%;\n}\n\n.item_text {\n    width: 100%;\n    height: 100%;\n    font-size: 16px;\n    color: #4f4f4f;\n    line-height: 23px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.error_message_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 35px;\n    height: 42px;\n    margin-top: 4px;\n}\n\n.error_message {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    padding: 0 12px;\n    border: 1px solid #E31A1A;\n    border-radius: 6px;\n    font-size: 16px;\n    color: #E31A1A;\n    background-color: #fde0d0;\n}\n\n.error_icon {\n    margin-right: 12px;\n}\n.content_mobile {\n    padding-left: 0!important;\n}\n.content_mobile .suggestion_box {\n    padding-left: 0;\n}\n.content_mobile .textarea_explain {\n    display: none;\n}\n.content_mobile .suggestion_box {\n    display: none;\n}\n.content_mobile .item_text {\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MessageInputBox_container__DZXSr`,
	"textarea_box": `MessageInputBox_textarea_box__bP5Eo`,
	"custom_textarea": `MessageInputBox_custom_textarea__hpo98`,
	"send_butn_img": `MessageInputBox_send_butn_img__qVJs+`,
	"thinking_loading_box": `MessageInputBox_thinking_loading_box__7lfPZ`,
	"circle_img": `MessageInputBox_circle_img__efFB+`,
	"spin": `MessageInputBox_spin__I1WyK`,
	"square_img": `MessageInputBox_square_img__UmHry`,
	"textarea_explain": `MessageInputBox_textarea_explain__EzBNB`,
	"error_box": `MessageInputBox_error_box__t0ZX7`,
	"suggestion_box": `MessageInputBox_suggestion_box__kOKVC`,
	"suggestion_title": `MessageInputBox_suggestion_title__eOS26`,
	"suggestion_item_box": `MessageInputBox_suggestion_item_box__TZ90G`,
	"item": `MessageInputBox_item__UG-y0`,
	"item1": `MessageInputBox_item1__xGBv4`,
	"item2": `MessageInputBox_item2__T2Wq6`,
	"item3": `MessageInputBox_item3__rGYQt`,
	"item_text": `MessageInputBox_item_text__zFplw`,
	"error_message_box": `MessageInputBox_error_message_box__Tsq6f`,
	"error_message": `MessageInputBox_error_message__myzrx`,
	"error_icon": `MessageInputBox_error_icon__5sJTi`,
	"content_mobile": `MessageInputBox_content_mobile__xeWuX`
};
export default ___CSS_LOADER_EXPORT___;
